import axios, { AxiosResponse } from 'axios'
import {
  ParametrosLogin,
  ParametrosPdfEncryption,
  ParametrosSenha,
  ParametrosSessao,
} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const CONFIG_URL = `${API_URL}/config`

const get = <T>(recurso: string): Promise<T> =>
  axios.get(`${CONFIG_URL}/${recurso}`).then((d: AxiosResponse<T>) => d.data)

const put = <T>(recurso: string, dto: T): Promise<T> =>
  axios.put(`${CONFIG_URL}/${recurso}`, dto).then((d: AxiosResponse<T>) => d.data)

export const getParametrosSenha = () => get<ParametrosSenha>('senha')
export const updateParametrosSenha = (dto: ParametrosSenha) => put('senha', dto)

export const getParametrosSessao = () => get<ParametrosSessao>('sessao')
export const updateParametrosSessao = (dto: ParametrosSessao) => put('sessao', dto)

export const getParametrosLogin = () => get<ParametrosLogin>('login')
export const updateParametrosLogin = (dto: ParametrosLogin) => put('login', dto)

export const getParametrosPdfEncryption = () => get<ParametrosPdfEncryption>('pdf-encryption')
export const updateParametrosPdfEncryption = (dto: ParametrosPdfEncryption) =>
  put('pdf-encryption', dto)
